@use '@lib/assets/styles/main.scss' as *;
.mainBlock {
  margin-bottom: 24px;
  & > div + div {
    margin-top: 16px;
  }
}

.questionBlock {
  margin-top: 8px;
}

.description {
  color: $gray500;
}

.questionTypeChip {
  margin-bottom: 8px;
}
